import { push as pushLocation } from "react-router-redux";
import RpcRepository from "./RpcRepository";
import MiscRepository from "../misc/MiscRepository";
import { fieldErrorsBackToFront } from "./../misc/dataConversion";
/* --- Action names --- */
export const RPC_ACTIONS = {
    /* Right Party Contact action names */
    REFERRAL_STARTED: "referral-started",
    REFERRAL_FAILED: "referral-failed",
    REFERRAL_SUCCEEDED_FALSE: "referral-succeeded-false",
    REFERRAL_SUCCEEDED_TRUE: "referral-succeeded-true"
};
/* --- For use on the ReferAuthorizedUser page. --- */
/**
 * Tracks landing on the refer authorized person form
 *
 * @method startReferAuthorizedPerson
 * @param {String} referenceNumber Reference number for related account
 * @param {String} pin Pin number for related account
 * @returns {Function} Redux thunk
 */
export const startReferAuthorizedPerson = (referenceNumber, pin) => async (_dispatch) => {
    if (!referenceNumber || !pin) {
        return;
    }
    // Send event tracking information
    try {
        await MiscRepository.trackEvent({
            event: "AddRightPartyContactStart",
            referenceNumber: referenceNumber.toString(),
            pin: pin.toString()
        });
    }
    catch (error) {
        return error;
    }
};
/**
 * Sends right person contact data to the API, dispatches appropriate actions to store,
 * then redirects to thank you page on success
 *
 * @method referAuthorizedPerson
 * @param {Object} info Value of referral form
 * @returns {Function} Redux thunk
 */
export const referAuthorizedPerson = (info) => async (dispatch) => {
    dispatch({ type: RPC_ACTIONS.REFERRAL_STARTED });
    let response;
    try {
        response = await RpcRepository.referAuthorized(info);
    }
    catch (error) {
        return dispatch({ type: RPC_ACTIONS.REFERRAL_FAILED, payload: error });
    }
    if ("errors" in response) {
        const preparedErrors = fieldErrorsBackToFront(response.errors);
        dispatch({ type: RPC_ACTIONS.REFERRAL_SUCCEEDED_FALSE, payload: preparedErrors });
    }
    else {
        dispatch({
            type: RPC_ACTIONS.REFERRAL_SUCCEEDED_TRUE
        });
        // Send event tracking information
        try {
            await MiscRepository.trackEvent({
                event: "AddRightPartyContactComplete",
                referenceNumber: info.referenceNumber.toString(),
                pin: info.pin.toString()
            });
        }
        catch (error) {
            return error;
        }
        dispatch(pushLocation("/public/thankYouRefer"));
    }
};



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/rpc/rpcActions.ts